<section class="config-container shadow">
  <h4 class="title configurator-subtitle">{{ 'closet-doors.door-configuration.recess-dimensions' | translate }}</h4>

  <div class="form-row">
    <div class="form-label">
      <label for="door-height">{{ 'closet-doors.door-configuration.door-height' | translate }}</label>
      <div class="subtitle">
        {{ 'closet-doors.door-configuration.from' | translate }} 1200
        {{ 'closet-doors.door-configuration.to' | translate }} 2600 mm
      </div>
    </div>
    <div class="form-input">
      <div class="mm">
        <input
          type="number"
          min="1200"
          max="2600"
          id="door-height"
          autocorrect="off"
          spellcheck="false"
          (change)="selectDoorHeight($event)"
          [(ngModel)]="current.closetDoors.doorHeight" />
      </div>
    </div>
  </div>

  <div class="form-row">
    <div class="form-label">
      <label for="door-width">{{ 'closet-doors.door-configuration.door-width' | translate }}</label>
      <div class="subtitle">
        {{ 'closet-doors.door-configuration.from' | translate }} {{ globalMinWidth }}
        {{ 'closet-doors.door-configuration.to' | translate }} {{ globalMaxWidth }} mm
      </div>
    </div>
    <div class="form-input">
      <div class="mm">
        <input
          type="number"
          [min]="globalMinWidth"
          [max]="globalMaxWidth"
          id="door-width"
          autocorrect="off"
          spellcheck="false"
          (change)="selectDoorWidth($event)"
          [(ngModel)]="current.closetDoors.doorWidth" />
      </div>
    </div>
  </div>
</section>
